(function(){
'use strict';

const ROOT = document.getElementById('formula-finder-root');
if (!ROOT) return;

const QUICK_START = ['Liver Qi Stagnation','Spleen Qi Deficiency','Kidney Yin Deficiency','Blood Deficiency','Shen Disturbance','Wind-Damp'];
const TABS = ['Pattern','Action','System','Therapeutic'];
const REF_PATTERNS = ['Bi Syndrome','Blood Deficiency','Blood Heat','Blood Stasis','Cold-Damp','Cold-Phlegm','Damp-Heat','Dampness','Edema','Exterior Invasion','Fire Toxin','Fluid Deficiency','Food Stagnation','Heart Blood Deficiency','Heart Fire','Heart Qi Deficiency','Heart Yin Deficiency','Intestinal Dryness','Jing Deficiency','Kidney Jing Deficiency','Kidney Yang Deficiency','Kidney Yin Deficiency','Liver Fire','Liver Qi Stagnation','Liver Wind','Liver Yang Rising','Lung Heat','Lung Qi Deficiency','Lung Yin Deficiency','Phlegm','Phlegm-Heat','Qi Deficiency','Qi Level Heat','Qi Sinking','Qi Stagnation','Qi and Blood Deficiency','Shao Yang','Shen Disturbance','Spleen Dampness','Spleen Qi Deficiency','Spleen Yang Deficiency','Stomach Heat','Stomach Qi Rebellion','Water Accumulation','Wind-Cold','Wind-Damp','Wind-Heat','Yang Collapse','Yang Deficiency','Yin Deficiency','Yin Deficiency with Empty Heat'];
const REF_ACTIONS = ['Calm Shen','Clear Damp-Heat','Clear Heat','Descend Qi','Dispel Stasis','Dispel Wind-Damp','Drain Dampness','Generate Fluids','Harmonize','Invigorate Blood','Nourish Heart','Open Channels','Promote Digestion','Regulate Qi','Release Exterior Wind-Cold','Release Exterior Wind-Heat','Resolve Toxin','Tonify Blood','Tonify Jing','Tonify Kidney','Tonify Qi','Tonify Yang','Tonify Yin','Transform Phlegm','Warm Interior'];
const isB2B = ROOT.dataset.b2b === 'true';

/* ── State ─────────────────────────────────────────────────────────────── */
let data = null;
let idxToStr = {};
let activeTab = 'Pattern';
let selected = {Pattern:[],Action:[],System:[],Therapeutic:[]};
let expandedId = null;
let brandFilter = '';
let cartFeedback = {};
let prevHadSelection = false;

/* ── Pricing ───────────────────────────────────────────────────────────── */
function dp(retail, wholesale) {
  return (isB2B && wholesale != null) ? wholesale : retail;
}

/* ── Data Loading ──────────────────────────────────────────────────────── */
async function loadData() {
  try {
    const url = ROOT.dataset.indexUrl;
    if (!url) { ROOT.innerHTML = '<p style="text-align:center;padding:80px 0;color:#ba1a1a;">Missing index URL.</p>'; return; }
    const r = await fetch(url);
    data = await r.json();
    idxToStr = {};
    [['patterns',data._patterns],['actions',data._actions],['systems',data._systems],
     ['therapeutic',data._therapeutic],['vendors',data._vendors],['types',data._types],['forms',data._forms]]
    .forEach(([k,arr]) => { idxToStr[k] = {}; arr.forEach((v,i) => idxToStr[k][i] = v); });
    applyUrlParams();
    renderApp();
    // Auto-scroll to results if URL params pre-selected anything
    const allSel = [...selected.Pattern,...selected.Action,...selected.System,...selected.Therapeutic];
    if (allSel.length > 0) {
      prevHadSelection = true;
      setTimeout(() => {
        const el = document.getElementById('ff-results');
        if (el) el.scrollIntoView({behavior:'smooth', block:'start'});
      }, 100);
    }
  } catch(e) {
    ROOT.innerHTML = '<p style="text-align:center;padding:80px 0;color:#ba1a1a;">Failed to load data. Please refresh.</p>';
  }
}

/* ── Decode helpers ────────────────────────────────────────────────────── */
function dv(p) { return idxToStr.vendors[p.v] || ''; }
function dt(p) { return idxToStr.types[p.pt] || ''; }
function df(p) { return p.fm !== undefined ? (idxToStr.forms[p.fm] || '') : ''; }
function da(p) {
  const o = [];
  if (p.ap !== undefined) o.push(idxToStr.actions[p.ap]);
  if (p.as) p.as.forEach(i => o.push(idxToStr.actions[i]));
  return o.filter(Boolean);
}
function dpa(p) { return (p.pa||[]).map(i => idxToStr.patterns[i]).filter(Boolean); }
function ds(p) { return (p.sy||[]).map(i => idxToStr.systems[i]).filter(Boolean); }
function dth(p) { return (p.th||[]).map(i => idxToStr.therapeutic[i]).filter(Boolean); }
function di(p) { return p.img ? data.imgBase + p.img : null; }

/* ── Filtering ─────────────────────────────────────────────────────────── */
/* ── URL parameter support ──────────────────────────────────────────────── */
function applyUrlParams() {
  const params = new URLSearchParams(window.location.search);
  const mapping = {pattern:'Pattern', action:'Action', system:'System', therapeutic:'Therapeutic'};
  const lookups = {pattern:data._patterns, action:data._actions, system:data._systems, therapeutic:data._therapeutic};
  for (const [param, dim] of Object.entries(mapping)) {
    const vals = params.getAll(param);
    for (const v of vals) {
      const decoded = decodeURIComponent(v);
      if (lookups[param].includes(decoded) && !selected[dim].includes(decoded)) {
        selected[dim].push(decoded);
      }
    }
  }
  // Set active tab to first dimension with selections
  for (const dim of TABS) {
    if (selected[dim].length > 0) { activeTab = dim; break; }
  }
}

function computeResults() {
  const allSel = [...selected.Pattern,...selected.Action,...selected.System,...selected.Therapeutic];
  if (!allSel.length) return [];
  const results = [];
  for (const p of data.products) {
    const pA=da(p), pP=dpa(p), pS=ds(p), pT=dth(p);
    const matched = [];
    for (const s of selected.Pattern) if (pP.includes(s)) matched.push(s);
    for (const s of selected.Action) if (pA.includes(s)) matched.push(s);
    for (const s of selected.System) if (pS.includes(s)) matched.push(s);
    for (const s of selected.Therapeutic) if (pT.includes(s)) matched.push(s);
    if (!matched.length) continue;
    results.push({...p, _a:pA, _p:pP, _s:pS, _t:pT, _v:dv(p), _tp:dt(p), _f:df(p), _img:di(p),
      _m:matched, _mc:matched.length, _tc:allSel.length});
  }
  results.sort((a,b) => b._mc !== a._mc ? b._mc - a._mc : a.t.localeCompare(b.t));
  return brandFilter ? results.filter(r => r._v === brandFilter) : results;
}

/* ── Handlers ──────────────────────────────────────────────────────────── */
function setTab(t) { activeTab = t; renderApp(); }
function toggle(dim, val) {
  const a = selected[dim];
  selected[dim] = a.includes(val) ? a.filter(v=>v!==val) : [...a, val];
  expandedId = null;
  renderApp();
  // Scroll to results on first selection
  const allSel = [...selected.Pattern,...selected.Action,...selected.System,...selected.Therapeutic];
  if (allSel.length === 1 && !prevHadSelection) {
    setTimeout(() => {
      const el = document.getElementById('ff-results');
      if (el) el.scrollIntoView({behavior:'smooth', block:'start'});
    }, 50);
  }
  prevHadSelection = allSel.length > 0;
}
function removeOne(val) {
  for (const k of TABS) selected[k] = selected[k].filter(v=>v!==val);
  prevHadSelection = [...selected.Pattern,...selected.Action,...selected.System,...selected.Therapeutic].length > 0;
  renderApp();
}
function clearAll() {
  selected = {Pattern:[],Action:[],System:[],Therapeutic:[]};
  expandedId = null; brandFilter = ''; prevHadSelection = false;
  renderApp();
}
function toggleExpand(h) { expandedId = expandedId === h ? null : h; renderApp(); }
function setBrand(v) { brandFilter = v; renderApp(); }

async function addToCart(key, variantId, qty) {
  cartFeedback[key] = 'adding'; renderApp();
  try {
    const r = await fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({items:[{id:variantId, quantity:qty||1}]})});
    if (!r.ok) throw new Error();
    cartFeedback[key] = 'added';
    try { const c = await fetch('/cart.js').then(r=>r.json());
      document.querySelectorAll('.header__cart-count,[data-cart-count]').forEach(el => el.textContent = c.item_count);
    } catch(e){}
  } catch(e) { cartFeedback[key] = 'error'; }
  renderApp();
  setTimeout(() => { delete cartFeedback[key]; renderApp(); }, 2500);
}

/* ── Render helpers ────────────────────────────────────────────────────── */
function esc(s) { const d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

function pill(text, dim) {
  const on = selected[dim].includes(text);
  return `<button role="option" aria-selected="${on}" class="ff-pill px-6 py-2.5 rounded-full border text-sm font-medium whitespace-nowrap ${
    on ? 'bg-on-surface text-white border-on-surface'
       : 'border-surface-container-high text-on-surface hover:border-primary-container hover:text-primary'
  }" data-pill="${esc(text)}" data-dim="${dim}">${esc(text)}</button>`;
}

function chip(text, matched) {
  return `<span class="inline-block px-2.5 py-0.5 rounded-full text-[11px] leading-relaxed ${
    matched ? 'bg-[#FFF3D6] text-[#B8860B] border border-primary-container'
            : 'bg-surface-container-low text-tertiary border border-transparent'
  }">${esc(text)}</span>`;
}

function cartBtn(key, vid, stk, size) {
  if (!stk) return `<span class="text-[11px] text-tertiary/40">Out of Stock</span>`;
  if (!vid) return '';
  const fb = cartFeedback[key];
  const cls = size === 'sm'
    ? 'px-3 py-1.5 text-xs rounded-md'
    : 'px-4 py-2 text-sm rounded-lg';
  const qcls = size === 'sm' ? 'w-11 py-1 text-xs' : 'w-12 py-1.5 text-xs';
  const btnColor = fb === 'added' ? 'bg-green-600 text-white'
    : fb === 'adding' ? 'bg-surface-container-high text-tertiary cursor-wait'
    : 'bg-primary-container text-on-primary-container hover:brightness-95';
  const label = fb === 'added' ? 'Added!' : fb === 'adding' ? '...' : 'Add';
  const qtyAttr = size === 'sm' ? `data-qty-r="${esc(key)}"` : `data-qty-v="${esc(key)}"`;
  const addAttr = size === 'sm' ? `data-add-row="${esc(key)}"` : `data-add-var="${esc(key)}"`;
  return `<div class="flex items-center gap-1.5 shrink-0">
    <input type="number" min="1" max="999" value="1" ${qtyAttr}
      class="ff-qty ${qcls} text-center border border-surface-container-high rounded-md bg-white text-on-surface"
      onclick="event.stopPropagation()" aria-label="Quantity">
    <button ${addAttr} data-vid="${vid}" class="ff-pill ${cls} font-semibold ${btnColor}">${label}</button>
  </div>`;
}

/* ── Main render ───────────────────────────────────────────────────────── */
function renderApp() {
  const allSel = [...selected.Pattern,...selected.Action,...selected.System,...selected.Therapeutic];
  const hasSel = allSel.length > 0;
  const results = hasSel ? computeResults() : [];
  const brands = [...new Set(data.products.map(p => dv(p)))].filter(Boolean).sort();
  let h = '';

  // ── Header
  h += `<header class="mb-8 md:mb-10">
    <h1 class="text-3xl md:text-4xl lg:text-5xl font-extrabold text-on-surface font-headline tracking-tight mb-1">Formula Finder</h1>
    <div class="flex items-center gap-3 mb-2">
      <span class="text-tertiary text-sm font-medium">Clinical Pattern Search</span>
      <span class="w-1.5 h-1.5 rounded-full bg-primary-container"></span>
      <span class="text-tertiary/50 text-sm">Professional Tool</span>
    </div>
    <p class="text-base md:text-lg text-tertiary/70 max-w-2xl leading-relaxed">Start from your diagnosis. Find formulas across every brand we carry.</p>
  </header>`;

  // ── Dx bar
  if (hasSel) {
    h += `<div class="bg-white rounded-xl px-4 py-3 mb-4 border border-surface-container-high flex items-center flex-wrap gap-2" role="status" aria-live="polite">
      <span class="text-[11px] font-bold text-tertiary/40 uppercase tracking-widest mr-1 select-none">Dx:</span>`;
    for (const s of allSel) {
      h += `<span class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[13px] font-medium bg-on-surface text-white select-none">
        ${esc(s)}<span class="cursor-pointer opacity-60 hover:opacity-100 text-base leading-none" data-remove="${esc(s)}" role="button" aria-label="Remove ${esc(s)}">&times;</span>
      </span>`;
    }
    h += `<button class="ml-auto text-xs text-tertiary/40 hover:text-tertiary" data-clear>Clear all</button></div>`;
    // Link to reference page for single pattern selection
    if (selected.Pattern.length === 1 && REF_PATTERNS.includes(selected.Pattern[0])) {
      const pSlug = selected.Pattern[0].toLowerCase().replace(/[^a-z0-9]+/g, '-');
      h += `<div style="margin:-4px 0 8px 0;padding-left:2px;"><a href="/pages/tcm-pattern-${pSlug}" style="font-size:12px;color:#7f5700;text-decoration:none;font-weight:500;transition:opacity 0.15s ease;" onmouseover="this.style.opacity='0.7'" onmouseout="this.style.opacity='1'">Learn about ${esc(selected.Pattern[0])} &rarr;</a></div>`;
    }
    // Link to action reference page
    if (selected.Action.length === 1 && REF_ACTIONS.includes(selected.Action[0])) {
      const aSlug = selected.Action[0].toLowerCase().replace(/[^a-z0-9]+/g, '-');
      h += `<div style="margin:-4px 0 8px 0;padding-left:2px;"><a href="/pages/tcm-action-${aSlug}" style="font-size:12px;color:#7f5700;text-decoration:none;font-weight:500;transition:opacity 0.15s ease;" onmouseover="this.style.opacity='0.7'" onmouseout="this.style.opacity='1'">Learn about ${esc(selected.Action[0])} &rarr;</a></div>`;
    }
  }

  // ── Selector panel
  h += `<div class="bg-white rounded-2xl overflow-hidden ghost-border" aria-label="Formula search filters">`;
  // Tab bar
  h += `<div class="flex border-b border-surface-container overflow-x-auto" role="tablist" aria-label="Search dimensions">`;
  for (const tab of TABS) {
    const on = activeTab === tab;
    const cnt = selected[tab].length;
    h += `<button role="tab" aria-selected="${on}" aria-controls="ff-panel" class="flex-1 min-w-[90px] py-3.5 text-sm tracking-wide ff-pill ${
      on ? 'font-bold border-b-2 border-primary-container text-primary-container'
         : 'font-medium text-tertiary hover:bg-surface-container-low border-b-2 border-transparent'
    }" data-tab="${tab}">
      ${tab}${cnt ? `<span class="ml-1.5 text-[10px] font-bold bg-primary-container text-white rounded-full px-[7px] py-px align-middle">${cnt}</span>` : ''}
    </button>`;
  }
  h += `</div>`;
  // Panel content — no fixed height, natural expansion
  h += `<div id="ff-panel" role="tabpanel" class="p-5 md:p-8 lg:p-10 space-y-6 md:space-y-8">`;
  h += renderSelector();
  h += `</div></div>`;

  // ── Results
  if (hasSel) {
    h += `<div id="ff-results" class="mt-6 pb-10">`;
    h += `<div class="flex justify-between items-center mb-4 flex-wrap gap-2">
      <span class="text-sm text-tertiary" aria-live="polite"><span class="font-semibold text-on-surface">${results.length}</span> formula${results.length!==1?'s':''} match${results.length===1?'es':''} your criteria</span>
      <div class="flex gap-2 items-center">
        <label for="ff-brand" class="text-xs text-tertiary/40">Brand:</label>
        <select id="ff-brand" class="text-sm py-1 px-2 rounded-md border border-surface-container-high bg-white text-on-surface" data-brand>
          <option value="">All Brands</option>
          ${brands.map(b=>`<option value="${esc(b)}"${brandFilter===b?' selected':''}>${esc(b)}</option>`).join('')}
        </select>
      </div>
    </div>`;
    for (const r of results) h += renderCard(r);
    if (!results.length) {
      h += `<div class="text-center py-16">
        <p class="text-on-surface font-medium mb-1">No formulas match all selected criteria</p>
        <p class="text-sm text-tertiary/50">Try removing a filter to broaden your search.</p>
      </div>`;
    }
    h += `</div>`;
  }

  // ── Empty state
  if (!hasSel) {
    h += `<div class="text-center py-16 md:py-20 max-w-xl mx-auto">
      <div class="text-5xl mb-3 opacity-[0.08] select-none">&#34765;</div>
      <h2 class="text-lg md:text-xl font-semibold text-on-surface mb-2 font-headline">Select a pattern, action, or system to begin</h2>
      <p class="text-sm text-tertiary/50 leading-relaxed mb-8">Search across ${data.productCount.toLocaleString()} herbal products from ${brands.length} brands. Organized the way you think in clinic.</p>
      <p class="text-[10px] font-bold text-tertiary/40 uppercase tracking-[0.15em] mb-4">Common starting points</p>
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        ${QUICK_START.map(p=>`<button class="bg-surface-container-low py-3.5 rounded-xl text-sm font-semibold text-on-surface hover:bg-primary-container hover:text-on-primary-container ff-pill text-center px-2 shadow-sm" data-quick="${esc(p)}">${esc(p)}</button>`).join('')}
      </div>
      <p class="text-[10px] text-tertiary/30 mt-12 leading-relaxed px-4">
        Formula Finder is a product search tool for licensed practitioners. It is not a diagnostic tool and does not constitute medical advice.
      </p>
    </div>`;
  }

  ROOT.innerHTML = h;
  bind();
}

/* ── Selector panel content ────────────────────────────────────────────── */
function renderSelector() {
  let h = '';
  if (activeTab === 'Pattern' || activeTab === 'Action') {
    const groups = activeTab === 'Pattern' ? data.taxonomy.patterns : data.taxonomy.actions;
    for (const [name, items] of Object.entries(groups)) {
      h += `<section><h3 class="text-[10px] font-bold text-on-surface-variant/50 uppercase tracking-[0.15em] mb-3">${esc(name)}</h3>
        <div class="flex flex-wrap gap-2 md:gap-2.5" role="listbox" aria-label="${esc(name)}">${items.map(i=>pill(i,activeTab)).join('')}</div></section>`;
    }
  } else {
    const items = activeTab === 'System' ? data.taxonomy.systems : data.taxonomy.therapeutic;
    h += `<div class="flex flex-wrap gap-2 md:gap-2.5" role="listbox" aria-label="${activeTab} options">${items.map(i=>pill(i,activeTab)).join('')}</div>`;
  }
  return h;
}

/* ── Result card ───────────────────────────────────────────────────────── */
function renderCard(r) {
  const full = r._mc === r._tc;
  const exp = expandedId === r.h;
  let h = `<div class="bg-white rounded-xl mb-3 border ${full?'border-primary-container':'border-surface-container-high'} cursor-pointer hover:shadow-sm" data-expand="${esc(r.h)}">`;
  h += `<div class="p-4 md:p-5">`;

  // Title row
  h += `<div class="flex justify-between items-start gap-3 mb-2">
    <div class="min-w-0">
      <div class="flex items-center gap-2 flex-wrap">
        <h3 class="text-base md:text-lg font-semibold text-on-surface tracking-tight leading-tight">${esc(r.t)}</h3>
        ${full?'<span class="text-[10px] font-bold text-primary-container uppercase tracking-wider whitespace-nowrap">Full Match</span>':''}
      </div>
      ${r.fn?`<p class="text-xs text-tertiary/50 mt-0.5">${esc(r.fn)}</p>`:''}
    </div>
    <div class="flex items-center gap-[3px] shrink-0 pt-1">
      ${Array.from({length:r._tc},(_,i)=>`<div class="w-[6px] h-[6px] rounded-full ${i<r._mc?'bg-primary-container':'bg-surface-container-high'}"></div>`).join('')}
      <span class="text-[10px] text-tertiary/40 ml-1">${r._mc}/${r._tc}</span>
    </div>
  </div>`;

  // Tag chips
  h += `<div class="flex flex-wrap gap-1 mb-2.5">`;
  for (const a of r._a) h += chip(a, r._m.includes(a));
  for (const p of r._p) h += chip(p, r._m.includes(p));
  h += `</div>`;

  // Systems
  h += `<div class="flex items-center gap-1.5 mb-3 flex-wrap">
    <span class="text-[10px] font-bold text-tertiary/40 uppercase tracking-[0.12em]">Systems</span>
    ${r._s.map((s,i)=>{const m=r._m.includes(s);return `${i?'<span class="text-surface-container-high text-xs">·</span>':''}<span class="text-xs ${m?'text-[#B8860B] font-medium':'text-tertiary/50'}">${esc(s)}</span>`}).join('')}
  </div>`;

  // Brand row
  h += `<div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">`;
  if (r._img) h += `<img src="${r._img}" alt="" class="w-[52px] h-16 object-contain rounded border border-surface-container-high/50" loading="lazy">`;
  h += `<div class="flex-1 min-w-0">
    <div class="text-sm font-medium text-on-surface">${esc(r._v)}</div>
    <div class="text-[11px] text-tertiary/40">${esc(r._f||r._tp)}</div>
  </div>
  <div class="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 w-full sm:w-auto">
    <div class="flex items-center gap-3">
      <span class="text-sm font-semibold text-on-surface">$${dp(r.pr,r.wpr).toFixed(2)}</span>
      <span class="flex items-center gap-1"><span class="w-1.5 h-1.5 rounded-full ${r.stk?'bg-green-600':'bg-red-400'}"></span><span class="text-[10px] text-tertiary/40">${r.stk?'In Stock':'Out of Stock'}</span></span>
    </div>
    <div class="w-full sm:w-auto">${cartBtn(r.h+'-row', r.vid, r.stk, 'sm')}</div>
  </div>`;
  h += `</div>`;

  h += `</div>`; // end p-5

  // Expanded detail
  if (exp) {
    h += `<div class="ff-expand-enter border-t border-surface-container-low px-4 md:px-5 py-4 md:py-5">`;
    // Tags grid
    h += `<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div><p class="text-[10px] font-bold text-tertiary/40 uppercase tracking-[0.12em] mb-2">Actions</p>
        <div class="flex flex-wrap gap-1">${r._a.map(a=>chip(a,r._m.includes(a))).join('')}</div></div>
      <div><p class="text-[10px] font-bold text-tertiary/40 uppercase tracking-[0.12em] mb-2">Patterns</p>
        <div class="flex flex-wrap gap-1">${r._p.map(p=>chip(p,r._m.includes(p))).join('')}</div></div>
    </div>`;
    h += `<div class="mb-4"><p class="text-[10px] font-bold text-tertiary/40 uppercase tracking-[0.12em] mb-2">Clinical Applications</p>
      <div class="flex flex-wrap gap-1">${r._t.map(t=>chip(t,r._m.includes(t))).join('')}</div></div>`;

    // Variant rows
    if (r.vars && r.vars.length > 0) {
      h += `<div class="space-y-2">`;
      for (const v of r.vars) {
        const vk = r.h+'-'+v.sku;
        h += `<div class="flex flex-col sm:flex-row sm:items-center justify-between gap-2 p-3 bg-surface-container-low rounded-lg">
          <div><div class="text-sm font-medium text-on-surface">${esc(v.title)}</div>
            <div class="text-[11px] text-tertiary/40">SKU: ${esc(v.sku)}</div></div>
          <div class="flex items-center gap-3">
            <span class="text-sm font-semibold">$${dp(v.pr,v.wpr).toFixed(2)}</span>
            ${cartBtn(vk, v.vid, v.stk, 'sm')}
          </div>
        </div>`;
      }
      h += `</div>`;
    } else {
      h += `<div class="flex justify-end">${cartBtn(r.h, r.vid, r.stk, 'md')}</div>`;
    }
    h += `</div>`;
  }

  h += `</div>`;
  return h;
}

/* ── Event binding ─────────────────────────────────────────────────────── */
function bind() {
  const on = (sel, evt, fn) => ROOT.querySelectorAll(sel).forEach(el => el.addEventListener(evt, fn));

  on('[data-tab]', 'click', function(){ setTab(this.dataset.tab); });
  on('[data-pill]', 'click', function(e){ e.stopPropagation(); toggle(this.dataset.dim, this.dataset.pill); });
  on('[data-remove]', 'click', function(e){ e.stopPropagation(); removeOne(this.dataset.remove); });
  on('[data-clear]', 'click', clearAll);
  on('[data-quick]', 'click', function(){ toggle('Pattern', this.dataset.quick); });
  on('[data-brand]', 'change', function(){ setBrand(this.value); });

  // Expand — ignore clicks on interactive children
  on('[data-expand]', 'click', function(e){
    if (e.target.closest('[data-add-row],[data-add-var],[data-qty-r],[data-qty-v],input,select')) return;
    toggleExpand(this.dataset.expand);
  });

  // Cart buttons
  on('[data-add-row]', 'click', function(e){
    e.stopPropagation();
    const k = this.dataset.addRow, vid = this.dataset.vid;
    const q = ROOT.querySelector(`[data-qty-r="${k}"]`);
    if (vid) addToCart(k, parseInt(vid), q ? Math.max(1,parseInt(q.value)||1) : 1);
  });
  on('[data-add-var]', 'click', function(e){
    e.stopPropagation();
    const k = this.dataset.addVar, vid = this.dataset.vid;
    const q = ROOT.querySelector(`[data-qty-v="${k}"]`);
    if (vid) addToCart(k, parseInt(vid), q ? Math.max(1,parseInt(q.value)||1) : 1);
  });
}

/* ── Boot ──────────────────────────────────────────────────────────────── */
loadData();
})();
